import gql from 'graphql-tag'
import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';

// 2
@Injectable({
  providedIn: 'root'
})
export class EditMoConvoypGql extends Mutation {
  document = gql`
           mutation editarLiberacionEmbarcacion(
                   $fecha: String!,
                   $convoyNumero: String!,
                   $convoyObs: String!
             ) {
               editarLiberacionEmbarcacion(
                  fecha: $fecha
                  convoyNumero: $convoyNumero
                  convoyObs: $convoyObs
               )
             }`;

}